import React from 'react';
import { TaskQuestionType } from '../../contract_enums';
import InvoiceQuestionChallenge from './InvoiceQuestionChallenge';
import PassKeyQuestionChallenge from './PassKeyQuestionChallenge';
import PhoneValidationChallenge from './PhoneValidationChallenge';
import ModalProgress from '../../../../Components/Progress/Modal/ModalProgress';

const challengeComponentMap = {
  [TaskQuestionType.RecentInvoice]: InvoiceQuestionChallenge,
  [TaskQuestionType.PassKey]: PassKeyQuestionChallenge,
  [TaskQuestionType.PhoneValidation]: PhoneValidationChallenge
};

const QuestionChallenge = ({ id, loading, ...props }) => {
  const ChallengeComponent = challengeComponentMap[id] || null;

  return (
    <>
      {loading && <ModalProgress message="Estamos validando tus respuestas" />}
      {ChallengeComponent && (
        <ChallengeComponent id={id} loading={loading} {...props} />
      )}
    </>
  );
};

export default QuestionChallenge;
